const tpKeyIndicator = {
  dc: 'DC',
  assessMonth: 'AssessMonth',
  assessMonthStart: 'StartMonth',
  assessMonthEnd: 'EndMonth',
  carrierCode: 'CarrierCode',
  serviceProvider: 'ServiceProvider',
  statType: 'StatType',
  onTimeDeliveryRate: 'OnTimeDeliveryRate',
  podTimelyRate: 'PODTimelyRate',
  rejectionRate: 'RejectionRate',
  createTime: 'CreateTime',
  msg: {}
};
export default tpKeyIndicator;



// WEBPACK FOOTER //
// ./src/page/assess/tpKeyIndicator/lang/tpKeyIndicator.en.js